<template>
  <!-- 使用案例 -->
  <div>
    <!-- 封面 -->
    <coverCom :catalog="bookCatalog" :coverData="coverData" v-show="coverShow" />
    <!-- 下一页 -->
    <p class="nextB">  <el-button type="primary" @click="nextBtn()" v-show="coverShow">下一页</el-button></p>
    
    <!-- 主要内容展示 -->
    <div class="contentDiv" v-show="!coverShow" >
      <readerCom :readerData="readerData"/>

    </div>
  </div>
  


</template>
  
  <script>
  import coverCom from '@/components/coverCom.vue'
  import readerCom from '@/components/readerCom.vue'
  export default {
  components: { coverCom ,readerCom},
  data() {
    return {
      bookCatalog: [
          {
            bid:1,
            children: [],
            fid: 0,
            id: 1,
            lastupdate: 1741055306923,
            name: "谱书封面",
            orders: 0,
            postdate: 1693810265207,
            type: 0,
          },
          {
            bid:1,
            children: [],
            fid: 0,
            id: 2,
            lastupdate: 1741055306923,
            name: "祖宗像赞",
            orders: 0,
            postdate: 1693810265207,
            type: 1,
          },
          {
            bid:1,
            children: [],
            fid: 0,
            id: 3,
            lastupdate: 1741055306923,
            name: "姓氏图腾",
            orders: 2,
            postdate: 1693810265207,
            type: 2,
          },
          {
            bid:1,
            children: [],
            fid: 0,
            id: 4,
            lastupdate: 1741055306923,
            name: "谱论题词",
            orders: 3,
            postdate: 1693810265207,
            type: 3,
          },
          {
            bid:1,
            children: [],
            fid: 0,
            id: 5,
            lastupdate: 1741055306923,
            name: "凡例",
            orders: 4,
            postdate: 1693810265207,
            type: 4,
          },
          {
            bid:1,
            children: [],
            fid: 0,
            id: 6,
            lastupdate: 1741055306923,
            name: "姓氏源流",
            orders: 5,
            postdate: 1693810265207,
            type: 5,
          },
          {
            bid:1,
            children: [],
            fid: 0,
            id: 7,
            lastupdate: 1741055306923,
            name: "家谱序言",
            orders: 6,
            postdate: 1693810265207,
            type: 6,
          },
          {
            bid:1,
            children: [],
            fid: 0,
            id: 8,
            lastupdate: 1741055306923,
            name: "家规",
            orders: 7,
            postdate: 1693810265207,
            type: 7,
          },
          {
            bid:1,
            children: [],
            fid: 0,
            id: 65,
            lastupdate: 1741055306923,
            name: "家训",
            orders: 7,
            postdate: 1693810265207,
            type: 17,
          },
          {
            bid:1,
            children: [],
            fid: 0,
            id: 9,
            lastupdate: 1741055306923,
            name: "字谱辈",
            orders: 8,
            postdate: 1693810265207,
            type: 8,
          },
          {
            bid:1,
            children: [],
            fid: 0,
            id: 10,
            lastupdate: 1741055306923,
            name: "家族成员信息（世系图）",
            orders: 9,
            postdate: 1693810265207,
            type: 9,
          },
          {
            bid:1,
            children: [],
            fid: 0,
            id: 11,
            lastupdate: 1741055306923,
            name: "家族照片",
            orders: 10,
            postdate: 1693810265207,
            type: 10,
          },
          {
            bid:1,
            children: [],
            fid: 0,
            id: 12,
            lastupdate: 1741055306923,
            name: "传记艺文",
            orders: 11,
            postdate: 1693810265207,
            type: 11,
          },
          {
            bid:1,
            children: [],
            fid: 0,
            id: 13,
            lastupdate: 1741055306923,
            name: "坟茔碑文",
            orders: 12,
            postdate: 1693810265207,
            type: 12,
          },
          {
            bid:1,
            children: [],
            fid: 0,
            id: 14,
            lastupdate: 1741055306923,
            name: "祠堂",
            orders: 13,
            postdate: 1693810265207,
            type: 13,
          },
          {
            bid:1,
            children: [],
            fid: 0,
            id: 15,
            lastupdate: 1741055306923,
            name: "大事记",
            orders: 14,
            postdate: 1693810265207,
            type: 14,
          },
          {
            bid:1,
            children: [],
            fid: 0,
            id: 16,
            lastupdate: 1741055306923,
            name: "编委会",
            orders: 15,
            postdate: 1693810265207,
            type: 15,
          },
          {
            bid:1,
            children: [],
            fid: 0,
            id: 17,
            lastupdate: 1741055306923,
            name: "后记",
            orders: 16,
            postdate: 1693810265207,
            type: 16,
          },
          
          
      ],
      //封面数据
      coverData:{
        fid: 11,
        id: 1,
        psmc: "孙氏的谱书",
        lastupdate: 1741055315697,
        psdz: "山东省莒县阎庄街道孙家山沟村孙其昌后裔族谱谱书",
        open: 1,
        postdate: 1693810265197,
        status: 0,
        uid: 11,
        bzr:'孙其昌后裔族谱编纂委员会',
        bzsj:'二0二三年十月',
        jh:'共一卷',
      },
      coverShow:true,//是否展示封面
      readerData:[],//谱书数据
    }
  },
  methods:{
    nextBtn(){
      alert('点击下一页  展示主要内容')
      this.coverShow=false
    }
  }
}
</script>
<style>
.nextB{
  text-align: center;
}
.nextB button{
  font-size: 18px;
}
.contentDiv{
  margin: 0 auto;
  border:1px solid #eee;
}

</style>


// WEBPACK FOOTER //
// src/views/text2.vue